import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Languages } from '../enums/languages.enum';
import { TranslationHelperService } from '../services/translation-helper.service';

export const languageInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const translationHelper = inject(TranslationHelperService);
  const currentLang = translationHelper.getCurrentLanguage || Languages.En;

  const langReq = req.clone({
    setHeaders: {
      'Accept-Language': currentLang,
    },
  });

  return next(langReq);
};
